import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-1"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  setup(__props) {


const { field, control, inputModel, handleUpdate } = inject('input') as InputInjection

// Make items reactive by using computed
const items = computed(() => {
  return field.value.items()
})

// Watch for changes in items and reset value if current value is no longer valid
watch(items, (newItems) => {
  // Evaluate the current value
  const currentValue = inputModel.value
  
  // Look up the current value in the updated list of items
  const isValidValue = newItems.some((item: any) => {
    // Handle arrays of objects with a title and a value property
    if (typeof item === 'object' && item.value !== undefined) {
      return item.value === currentValue
    }
    // Handle arrays of strings
    return item === currentValue
  })
  
  // If the current value has become invalid, reset it to default or null
  if (!isValidValue) {
    const defaultValue = field.value.default
    inputModel.value = defaultValue !== undefined ? defaultValue : null
  }
}, { deep: true })

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_sync_marker = _resolveComponent("hy-inputs-sync-marker")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps({
    modelValue: _unref(inputModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null))
  }, _unref(control), {
    items: _unref(items),
    "onUpdate:modelValue": _unref(handleUpdate)
  }), _createSlots({ _: 2 }, [
    (_unref(showAppend))
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.$ui.showSync && _unref(control).sync)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_hy_inputs_sync_marker, {
                      sources: _unref(control).sync
                    }, null, 8, ["sources"])
                  ]))
                : (_unref(control).flag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_tooltip, { bottom: "" }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                            _createVNode(_component_hy_icon, {
                              name: "Warning",
                              small: ""
                            })
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(control).flag), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_unref(control).help)
                    ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                        key: 2,
                        "help-prompt": _unref(control).help
                      }, null, 8, ["help-prompt"]))
                    : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "items", "onUpdate:modelValue"]))
}
}

})